<template>
    <ideo-form-group :label="$t('[[[Grupa]]]')" :invalid-feedback="form.$errors.first('settings.bannerGroupId')" :state="form.$errors.state('settings.bannerGroupId')" required>
        <ideo-autocomplete
            v-model="form.settings.bannerGroupId"
            name="settings.bannerGroupId"
            track-by="id"
            :placeholder="$t('[[[zacznij pisać aby wyszukać grupę...]]]')"
            :fetch="(id: number) => fetchSlider(id)"
            :search="(query: string, limit: number) => searchSliders(query, limit)"
            :disabled="form.language === null"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
        </ideo-autocomplete>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import { Option } from '@/helpers/Interfaces';
import { FormType } from '@/helpers/Form';
import { ValidatableComponent } from '@/components/cms';
import merge from 'lodash/merge';
import BannerGroupsService, { ListItemModel } from '@/modules/cms/banners/services/BannerGroupsService';

@Options({
    name: 'widget-banners-settings'
})
export default class BannersSettings extends Vue implements ValidatableComponent
{
    @Prop() public modelValue!: any;

    public defaults: any = {
        bannerGroupId: ''
    };

    public get form(): any
    {
        return this.modelValue;
    }

    public get quantity(): Option<number>[]
    {
        return new Array(10).fill(null).map((value, index) =>
        {
            return { value: index + 1, text: (index + 1).toString() };
        });
    }

    public async created(): Promise<void>
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }

    public async validate(): Promise<void>
    {
    }

    public async fetchSlider(id: number): Promise<ListItemModel>
    {
        const response = await BannerGroupsService.fetchAutocompleteModel(id);

        return response.first();
    }

    public async searchSliders(query: string, limit: number): Promise<ListItemModel[]>
    {
        return await BannerGroupsService.getAutocompleteList(query, limit, false);
    }
}
</script>
